import styled from '@emotion/styled';
import { Report } from '@gameonly/core';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useReport from '../annual-reports/context/useReport';
import { HeaderContainer, HeaderSection } from '../layout/Header';

import { useTranslation } from 'react-i18next';
import keyify from '../project/parameters/keyify';
import { ReactComponent as Home } from '../ui/icons/home.svg';
import { ReactComponent as Next } from '../ui/icons/next.svg';
import { MiddleSection, RightSection } from '../layout/Header/Headers';

const BreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  svg {
    fill: white;
  }
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const Breadcrumb = ({
  report,
  projectId,
}: {
  report?: Report;
  projectId?: string;
}) => {
  const { t } = useTranslation(['annual-reports', 'common', 'model']);
  const navigate = useNavigate();
  const project = report?.projects?.find(
    (project) => project._id.toString() === projectId,
  );
  const translationPrefix = `model:${keyify(project?.model.name)}`;
  return (
    <BreadcrumbWrapper>
      <IconContainer onClick={() => navigate('/')}>
        <Home />
      </IconContainer>
      <IconContainer>
        <Next />
      </IconContainer>
      <Link to={`/annual-reports`} className="h6r underline">
        {t('annual-reports:title')}
      </Link>
      {!!report && (
        <>
          <IconContainer>
            <Next />
          </IconContainer>
          <Link to={`/annual-reports/${report._id}`} className="h6r underline">
            {t('annual-reports:report.title', { name: report.name })}
          </Link>

          {project && (
            <>
              <IconContainer>
                <Next />
              </IconContainer>
              <Link
                to={`/annualreports/${report._id}/${project._id}`}
                className="h6r underline"
              >
                {t(`${translationPrefix}.singularName`)} - {project.name}
              </Link>
            </>
          )}
        </>
      )}
    </BreadcrumbWrapper>
  );
};
const HeaderAnnualReports = () => {
  const { reportId, projectId } = useParams();
  const { report } = useReport(reportId);
  return (
    <HeaderContainer>
      <HeaderSection>
        <Breadcrumb report={report} projectId={projectId} />
      </HeaderSection>
      <HeaderSection marginBetween="16px" centered>
        <MiddleSection />
      </HeaderSection>
      <HeaderSection marginBetween="16px">
        <RightSection />
      </HeaderSection>
    </HeaderContainer>
  );
};
export default HeaderAnnualReports;
